export default "__VITE_ASSET__DcLKDNuw__";